import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PutEntityFormFields {

    public name: FormField
    public description: FormField
    public editPermissions: FormField
    public project: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          false,
        )
        this.description = new FormField(
          'description',
          'Description',
          null,
          FormFieldType.text,
          false,
          true,
          ""
        )
        this.editPermissions = new FormField(
          'editPermissions',
          'Edit permissions',
          null,
          FormFieldType.boolean,
          false,
        )
        this.project = new FormField(
          'project',
          'Project',
          'project',
          FormFieldType.pushedSelectionList,
          false,
        )

    }
}

const fields = new PutEntityFormFields()

export const putEntityFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  description: fields.description,
  editPermissions: fields.editPermissions,
  project: fields.project,
};